import { render, staticRenderFns } from "./DesignerParameter.vue?vue&type=template&id=1710d4c5&scoped=true"
import script from "./DesignerParameter.vue?vue&type=script&lang=ts"
export * from "./DesignerParameter.vue?vue&type=script&lang=ts"
import style0 from "./DesignerParameter.vue?vue&type=style&index=0&id=1710d4c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1710d4c5",
  null
  
)

export default component.exports